import moment from "moment";
import "moment-duration-format";
import NumberUtils from "util/NumberUtils";
export const formatDuration = (ms) => moment.duration(ms, "milliseconds").format("m[m], s[s], S[ms]");
const INTERVAL_UNITS = [
  { label: "day", ms: 24 * 60 * 60 * 1e3 },
  { label: "hour", ms: 60 * 60 * 1e3 },
  { label: "minute", ms: 60 * 1e3 },
  { label: "second", ms: 1e3 }
];
export const formatInterval = (intervalMs) => {
  let remaining = intervalMs;
  const parts = INTERVAL_UNITS.reduce((acc, { label, ms }) => {
    const value = Math.floor(remaining / ms);
    if (value === 0) return acc;
    remaining -= value * ms;
    return [...acc, { value, label }];
  }, []);
  if (parts.length === 0) return "less than a second";
  if (parts.length === 1 && parts[0].value === 1) return parts[0].label;
  return parts.map(({ value, label }) => `${value} ${label}${value === 1 ? "" : "s"}`).join(" ");
};
export const formatTokenUsage = (usage) => [
  `${NumberUtils.formatNumber(usage.input_tokens)} in`,
  `${NumberUtils.formatNumber(usage.output_tokens)} out`,
  `${NumberUtils.formatNumber(usage.total_tokens)} total`
].join(" \xB7 ");
export const hasConfiguredModelProvider = (config) => Boolean(config.default_provider && config.default_model_id);
